import { Injectable, inject, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import {
  Auth,
  FacebookAuthProvider,
  GoogleAuthProvider,
  signInWithPopup,
  signOut,
  user,
} from '@angular/fire/auth';
import { Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class LoginService {
  private auth = inject(Auth);
  private router = inject(Router);

  readonly isOpen = signal(false);
  // undefined = Firebase jeszcze ładuje sesję | null = niezalogowany | User = zalogowany
  readonly user = toSignal(user(this.auth), { initialValue: undefined });

  open() { this.isOpen.set(true); }
  close() { this.isOpen.set(false); }

  async signInWithGoogle(): Promise<void> {
    await signInWithPopup(this.auth, new GoogleAuthProvider());
    this.close();
  }

  async signInWithFacebook(): Promise<void> {
    // Bez jawnych scope'ów — Firebase i tak żąda `public_profile,email` po
    // stronie serwera. Jeśli Meta zwraca „Invalid Scopes: email", uprawnienie
    // trzeba dodać w panelu Meta; z poziomu kodu się tego nie wyłączy.
    // Adresu e-mail nigdzie nie używamy, konto identyfikuje `uid`.
    await signInWithPopup(this.auth, new FacebookAuthProvider());
    this.close();
  }

  async signOut(): Promise<void> {
    // Najpierw zejdź z /admin/*, dopiero potem wyloguj. Odwrotna kolejność
    // budzi effecty tych widoków na `user === null` i otwierają modal
    // logowania, zanim router zdąży zdjąć komponent.
    if (this.router.url.startsWith('/admin')) {
      await this.router.navigateByUrl('/');
    }
    await signOut(this.auth);
  }
}
